import React from 'react'
import Extra from './extra/Extra'
import classes from './styles.module.css'
import Management from './management'
import Services from './services'
import Review from './review'
import FAQS from './faqs'

interface IFooter {
  showExtraSection?: boolean
  showReviewSection?: boolean
  showFAQSection?: boolean
}
export default function Footer({
  showExtraSection = false,
  showReviewSection = true,
  showFAQSection = false,
}: IFooter) {
  return (
    <>
      <div className={classes.parentContainer}>
        <div
          className={classes.container}
          style={{
            paddingTop: !showExtraSection && !showReviewSection && !showFAQSection ? '0' : '7.5rem',
            background:
              !showExtraSection && !showReviewSection && !showFAQSection
                ? 'transparent'
                : 'var(--blue-1)',
          }}
        >
          <div className={classes.subContainer}>
            {showExtraSection && <Extra />}
            {showReviewSection && <Review showExtraSection={showExtraSection} />}
            {showFAQSection && <FAQS />}
          </div>
          <div className={classes.secondContainer}>
            <div className={classes.subContainer}>
              <Management />
              <Services />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
